class SectionIntro{
    constructor(el){
        this.DOM = el;
        // console.log("section-intro", this.DOM)
    }
    static bind(){
        const elements = document.querySelectorAll('.section-intro')
        elements.forEach(el => new SectionIntro(el))
    }
}
SectionIntro.bind()
        